module.exports = __webpack_public_path__ + "img/20250219-01-01.1d805c91.png";